<style lang="scss" scoped>
.require-star {
    left: 25px;
    top: 2px;
    position: absolute;
    color: #ed3f14ed;
}
</style>
<template>
    <div>
        <vForm
            v-if="type != 'query'"
            :label-width="100"
            :show-message="false"
            :model="formData"
            class="clearfix margin-top-15"
            ref="baseform"
        >
            <vCol span="10">
                <vFormItem
                    :label="
                        $t('boss.purchase.contact_name', {
                            defaultValue: '联系人姓名',
                        })
                    "
                    style="position: relative"
                >
                    <span class="require-star">*</span>
                    <vInput v-model="formData.contact"></vInput>
                </vFormItem>
            </vCol>
            <!-- <Col span="8">
                <vFormItem label='联系人QQ' >
                    <vInput v-model="formData.contactQq"></vInput>
                </vFormItem>
            </Col> -->
            <vCol span="10">
                <vFormItem
                    :label="
                        $t('boss.purchase.contact_phone', {
                            defaultValue: '联系人电话',
                        })
                    "
                    style="position: relative"
                >
                    <span class="require-star">*</span>
                    <vInput v-model="formData.contactTel"></vInput>
                </vFormItem>
            </vCol>
            <vCol span="10">
                <vFormItem
                    :label="
                        $t('boss.purchase.contact_email', {
                            defaultValue: '联系人邮箱',
                        })
                    "
                >
                    <vInput v-model="formData.contactEmail"></vInput>
                </vFormItem>
            </vCol>
            <vCol span="10">
                <vFormItem
                    :label="
                        $t('boss.purchase.contact_email', {
                            defaultValue: '其他联系方式',
                        })
                    "
                >
                    <vInput v-model="formData.contactOther"></vInput>
                </vFormItem>
            </vCol>
            <vCol span="3">
                <vButton
                    class="margin-left-20"
                    theme="primary"
                    @click="addItem"
                    >{{
                        $t("boss.purchase.add", { defaultValue: "添加" })
                    }}</vButton
                >
            </vCol>
        </vForm>
        <div span="24">
            <vButton
                v-if="type != 'query'"
                class="margin-left-20 margin-bottom-10"
                theme="error"
                @click="cleartable"
                >{{
                    $t("boss.purchase.clear_all", { defaultValue: "全部清除" })
                }}</vButton
            >
            <vTable
                class="margin-15"
                :columns="columns"
                :data="formList"
                size="small"
                ref="tablequery"
                border
            ></vTable>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
    props: ["connectdata", "type"],
    components: {
        compFormEdit: () => import("@components/templates/formedit"),
    },
    data() {
        return {
            loading1: false,
            formData: {},
            formList: [],
            required: [
                {
                    required: true,
                    message: this.$t("boss.purchase.fill_in", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
        };
    },
    computed: {
        // ...mapState('boss', ['products', 'accountTypes', 'accounts']),
        columns() {
            let _this = this;
            let array = [
                {
                    title: this.$t("boss.purchase.contact_name", {
                        defaultValue: "联系人姓名",
                    }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>
                                    {row.contact}
                                    <span
                                        style={`margin-left: 10px; display: ${
                                            row.isDefault === 1
                                                ? "inline-block"
                                                : "none"
                                        }; background-color: #52d510; color: #fff; padding: 2px 5px; border-radius: 5px;`}
                                    >
                                        {this.$t("boss.purchase.default", {
                                            defaultValue: "默认",
                                        })}
                                    </span>
                                </div>
                            </div>
                        );
                    },
                },
                // {
                //     title: "联系人QQ",
                //     key:'contactQq',
                // },
                {
                    title: this.$t("boss.purchase.contact_phone", {
                        defaultValue: "联系人电话",
                    }),
                    key: "contactTel",
                },
                {
                    title: this.$t("boss.purchase.contact_email", {
                        defaultValue: "联系人邮箱",
                    }),
                    width: 200,
                    key: "contactEmail",
                },
                {
                    title: this.$t("boss.purchase.other_contact_information", {
                        defaultValue: "其他联系方式",
                    }),
                    width: 200,
                    key: "contactOther",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    width: 160,
                    render(h, { row, index }) {
                        let setDefault = h(
                            "Button",
                            {
                                props: {
                                    type: "primary",
                                    size: "small",
                                },
                                on: {
                                    click: () => {
                                        _this.setDefault(index);
                                    },
                                },
                                style: {
                                    "margin-right": "5px",
                                },
                            },
                            this.$t("boss.purchase.set_as_default", {
                                defaultValue: "设为默认",
                            })
                        );
                        if (row.isDefault === 1) {
                            setDefault = h(
                                "Button",
                                {
                                    props: {
                                        type: "success",
                                        size: "small",
                                    },
                                    style: {
                                        "margin-right": "5px",
                                    },
                                },
                                this.$t("boss.purchase.current_default", {
                                    defaultValue: "当前默认",
                                })
                            );
                        }
                        return h("div", [
                            setDefault,
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.comremove(index);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.delete", {
                                    defaultValue: "删除",
                                })
                            ),
                        ]);
                    },
                },
            ];
            if (this.type == "query") {
                array.splice(4, 1);
            }
            return array;
        },
    },
    methods: {
        setDefault(index) {
            this.formList.map((item, nowIndex) => {
                if (nowIndex === index) {
                    item.isDefault = 1;
                } else {
                    item.isDefault = 0;
                }
            });
        },
        addItem() {
            if (!this.formData.contact || !this.formData.contactTel) {
                return this.$VMessage.error(
                    this.$t("boss.purchase.fill_name_phone", {
                        defaultValue: "请填写联系人姓名和电话",
                    })
                );
            }
            let flag = true;
            this.$refs.baseform.validate((valid) => {
                if (!valid) {
                    flag = false;
                }
            });
            if (!flag) return;
            let isDefault = 0;
            if (this.formList.length === 0) {
                isDefault = 1;
            }
            let data = {
                contact: this.formData.contact,
                contactTel: this.formData.contactTel,
                contactEmail: this.formData.contactEmail,
                // contactQq:this.formData.contactQq,
                contactOther: this.formData.contactOther,
                isDefault: isDefault,
            };
            this.formData = {};
            this.formList.push(data);
        },
        comremove(index) {
            this.formList.splice(index, 1);
        },
        cleartable() {
            this.formList = [];
        },
    },
    watch: {
        connectdata: {
            deep: true,
            handler(val) {
                // console.log(val)
                this.formList = val;
            },
        },
    },
};
</script>
